import { render, staticRenderFns } from "./site_template.vue?vue&type=template&id=32f45896"
import script from "./site_template.vue?vue&type=script&lang=ts"
export * from "./site_template.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports